import { foundations } from '../foundations';
const { colors, space, textStyles } = foundations;

export const Card = {
  baseStyle: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
    container: {
      marginBottom: space['6'],
      backgroundColor: colors.background.container[colorMode],
    },
    header: {
      paddingTop: space['3'],
      paddingBottom: space['3'],
      fontSize: textStyles.sectionHeading.fontSize,
      fontWeight: textStyles.sectionHeading.fontWeight,
      borderBottom: `1px solid ${colors.border.transparent[colorMode]}`,
    },
    footer: {
      borderTop: `1px solid ${colors.border.transparent[colorMode]}`,
    },
  }),
  variants: {
    /**
     * TODO: better variant name, one that is more generic and related to the type of card?
     * We'll have a better idea of what to name this once we have more cards to compare.
     */
    orderForm: {
      container: {
        // To be specified by parent Stack spacing
        m: '0',
        // no border radius on mobile/tablet
        borderRadius: ['0', '0', '0.5rem'],
        boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)',
        width: 'inherit',
      },
    },
    orderFormInner: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      container: {
        p: '0.75rem',
        mb: '1rem',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: colors.border.transparent[colorMode],
        shadow: 'none',
      },
    }),
  },
};
